import Vue from 'vue'
import { getCurrentUrlWithoutParameters } from '../utils'

// For testing environment
//const baseUrl = 'https://fox.ix0.eu:3443/ExternalModules/Levi-Widget/WINRES_JOIKU2'

// For production environment
const baseUrl = 'https://wacs2.paas.datacenter.fi/ExternalModules/Levi-Widget/WINRES_LEVI'


export const getActivityById = (id, lang) => {

  return fetch(`${baseUrl}/products/` + id + '?lang=' + lang, {
    method: 'GET',
    headers: {}
  })
    .then(_ => _.json())
    .catch(err => {
      Vue.rollbar.error(err);      
      return err
    })
}

export const getCalendar = (productId, year, month, participants, lang) =>  {

  let participantStrings = []

  if (participants) {
    let i;
    const keys = Object.keys(participants)
    for (i = 0; i < keys.length; i++) {
      if (participants[keys[i]] > 0) {
        participantStrings.push('cat_' + keys[i] + '=' + participants[keys[i]])
      }
    }
  }
  
  const participantQuery = participantStrings.join('&')

  return fetch(`${baseUrl}/products/${productId}/calendar/${year}/${month}?lang=${lang}${'&' + participantQuery}`, {
    method: 'GET',
    headers: {}
  })
    .then(_ => _.json())
    .catch(err => {
      Vue.rollbar.error(err);
      return err
    })
}

export const getCheckout = (productId, date, startTimeId, participants, rate, lang, pickup, dropoff, orderExtras) => {
  return fetch(`${baseUrl}/checkout/options/booking-request?lang=${lang}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      activityBookings: [
        {
          activityId: productId,
          date: date,
          rateId: rate.rateId,
          startTimeId: startTimeId,
          passengers: participants,
          extras: orderExtras,
          ...pickup,
          ...dropoff
        }
      ]
    })
  })
    .then(_ => _.json())
    .catch(err => {
      Vue.rollbar.error(err);
      return err
    })
}

export const getPickupPlaces = (productId, lang) => { 
  return fetch(`${baseUrl}/products/${productId}/pickup-places?lang=${lang}`, {
    method: 'GET',
    headers: {}
  })
    .then(_ => _.json())
    .catch(err => {
      Vue.rollbar.error(err);
      return err
    })
}

export const getPaymentData = (
  productId,
  date,
  startTimeId,
  participants,
  answers,
  pickupDetails,
  dropoffDetails,
  mainContactDetails,
  orderExtras,
  lang,
  rate,
  widgetData,
  paymentMethod
) => {
  const currentUrl = getCurrentUrlWithoutParameters()
  return fetch(`${baseUrl}/prebookings?lang=${lang}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      mainContactDetails: mainContactDetails,
      returnUrl: currentUrl,
      ...(paymentMethod && { paymentMethodId: paymentMethod.id }),
      activityBookings: [
        {
          activityId: productId,
          answers: answers,
          pickupAnswers: [],
          dropoffAnswers: [],
          date: date,
          rateId: rate.rateId,
          startTimeId: startTimeId,
          passengers: participants,
          ...pickupDetails,
          ...dropoffDetails,
          extras: orderExtras
        }
      ],
      widgetData: JSON.stringify(widgetData)
    })
  })
    .then(_ => _.json())
    .catch(err => {
      Vue.rollbar.error(err);
      return err
    })
}

export const getPrebookingById = (id, token, lang) => { 
  return fetch(`${baseUrl}/prebookings/${id}?token=${token}&lang=${lang}`, {
    method: 'GET',
    headers: {}
  })
    .then(_ => _.json())
    .catch(err => {
      Vue.rollbar.error(err);
      return err
    })
}

